export const BUSINESS_LEGAL_REPRESENTATIVE_RESOURCE_NAME = 'business-legal-representative';
